import { Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useAuth } from 'react-oidc-context';
import './App.css';

function Home({ userInfo }) {

  const auth = useAuth();

  return (
    <div>
      <Typography fontWeight="bold" sx={{ marginTop: 4 }} align='center' variant='h4'><FormattedMessage id="Home.welcome" /></Typography>
      {userInfo?.username && <Typography sx={{ marginTop: 4 }} align='center' variant='h5'>{userInfo?.username}</Typography>}
    </div>
  );
}
export default Home;